import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

import "./AchLastNameInput.scss";

interface AchLastNameInputProps {
    achLastName: string;
    onSetAchLastName: (lastName: string) => void;
    onSetIsAchLastNameValid: (isLastNameValid: boolean) => void;
}

export const AchLastNameInput: React.FunctionComponent<AchLastNameInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredAchFirstNameError = 'Last Name is a required field.';

    useEffect(() => {
        props.onSetIsAchLastNameValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetAchLastName(value);
        validateAchLastName();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAchLastName();
    }

    const validateAchLastName = () => {
        let errorsTemp: string[] = [];
        if (props.achLastName === '') {
            errorsTemp.push(requiredAchFirstNameError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div className="ach-last-name-container">
        <Input isValid={isValid} type='text' required={true} value={props.achLastName} onChange={onChange}
               onKeyUp={onKeyUp}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
